var React = require('react');

function Xicon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#d71c2e","fillRule":"nonzero","stroke":"none","strokeWidth":"1","strokeLinecap":"butt","strokeLinejoin":"miter","strokeMiterlimit":"10","strokeDasharray":"","strokeDashoffset":"0","fontFamily":"none","fontWeight":"none","fontSize":"none","textAnchor":"none","style":{"mixBlendMode":"normal"}},React.createElement("g",{"transform":"scale(8.53333,8.53333)"},React.createElement("path",{"d":"M6,4c-1.105,0 -2,0.895 -2,2v18c0,1.105 0.895,2 2,2h18c1.105,0 2,-0.895 2,-2v-18c0,-1.105 -0.895,-2 -2,-2zM8.64844,9h4.61133l2.69141,3.84766l3.33008,-3.84766h1.45117l-4.12891,4.78125l5.05078,7.21875h-4.61133l-2.98633,-4.26953l-3.6875,4.26953h-1.47461l4.50586,-5.20508zM10.87891,10.18359l6.75391,9.62695h1.78906l-6.75586,-9.62695z"}))));
}

Xicon.defaultProps = {"viewBox":"0,0,256,256","width":"27px","height":"27px","fillRule":"nonzero"};

module.exports = Xicon;

Xicon.default = Xicon;
